export const globalStyleSheet = new CSSStyleSheet();
globalStyleSheet.replaceSync(`
  *, :host {
    box-sizing: border-box;
  }
  
  * {
    font-family: Roboto, sans-serif;
    box-sizing: border-box;

    background-repeat: no-repeat;
    background-position: center;

    color: var(--color-primary-text);
    line-height: 120%;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  h1 {
    font-size: var(--font-h1-size);
  }

  h2 {
    font-size: var(--font-h2-size);
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  body {
    margin: 0;
    overflow-x: hidden;
  }
  }

  button.close {
    background-color: transparent;
    background-image: url(/src/assets/images/close.svg);
    background-size: 100%;
    border-color: transparent;
    width: 30px;
    height: 30px;
  }

  .hidden {
    display: none;
  }

  dialog {
    background-color: var(--color-block);
    max-width: none;
    max-height: none;
    padding: 14px;
    margin: 0;
    width: 100dvw;
    height: 100dvh;
    border: 0;

    & > .content {
      max-width: 700px;
      width: 100%;
      margin: 0 auto;
    }
  }

  .pair-buttons-container {
    display: flex;
    gap: 10px;

    & > * {
      width: 100%;
    }
  }

   button {
    cursor: pointer;
    border: none;
    border-radius: 4px;
    padding: 8px 10px;

    &.primary {
      background-color: var(--color-focus);
    }

    &.secondary {
      background-color: var(--color-button-secondary);
    }

    &:disabled {
      background-color: var(--color-disabled-button);
    }
  }
`);
